import { render, staticRenderFns } from "./ProductTimeDiscountList.vue?vue&type=template&id=6664d646&"
import script from "./ProductTimeDiscountList.vue?vue&type=script&lang=js&"
export * from "./ProductTimeDiscountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports